import { useNavigate } from 'react-router-dom'

import { TimeoffPolicyAddEmployeeModalPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import AddEmployeeModal from 'modules/timeoff/components/TimeoffPolicy/AddEmployee'
import AddEmployeeAssignmentModal from 'modules/timeoff/components/TimeoffPolicy/AddEmployeeAssignment'
import { hasPolicyTemporality } from 'modules/timeoff/lib/features/TimeoffFeatures'

const AddEmployeeModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useStrictParams<'id'>()
  const timeoffPolicyId = String(id)

  const { data, loading } = useQuery(TimeoffPolicyAddEmployeeModalPageDocument, {
    variables: {
      timeoffPolicyId,
    },
  })

  const onClose = () => {
    navigate(navigation.settings.timeoffPolicies.id.employees.fullPath({ id }))
  }

  if (hasPolicyTemporality()) {
    const timeoffPolicyEmployeeIds =
      data?.timeoff.currentPolicyAssignments.map((assignment) => assignment.employeeId) ?? []

    return (
      <AddEmployeeAssignmentModal
        loading={loading}
        timeoffPolicyId={String(id)}
        timeoffPolicyEmployeeIds={timeoffPolicyEmployeeIds}
        onClose={onClose}
      />
    )
  }

  const timeoffPolicyEmployeeIds =
    data?.employees.employeeNames.map((employee) => employee.id) ?? []
  const timeoffPolicyAllowances = data?.timeoff.allowances ?? []

  return (
    <AddEmployeeModal
      loading={loading}
      timeoffPolicyId={timeoffPolicyId}
      timeoffPolicyEmployeeIds={timeoffPolicyEmployeeIds}
      timeoffPolicyAllowances={timeoffPolicyAllowances}
      onClose={onClose}
    />
  )
}

export default AddEmployeeModalPage
